import { environment } from "@/env/env.prod"
import Cookies from "js-cookie"

class PlacementService {

    constructor() {
        this.baseApi = `${environment.BASE_URL}/placementPortal`
    }

    // -----------------------------------------
    // INTERNAL HELPERS
    // -----------------------------------------

    getHeaders() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("authToken")}`,
            "X-INSTITUTE": Cookies.get("ins_code"),
            "X-E-ID": Cookies.get("E_id"),
            "X-FACULTY": Cookies.get("Fac") || "1",
            "X-PARENT": Cookies.get("ins_code"),
        }
    }

    toPayload(job) {
        return {
            title: job.title,
            company: job.company,
            genre: job.genre,
            employmentType: job.employmentType,
            workMode: job.workMode,
            description: job.description || "",
            siteUrl: job.siteUrl,
            createdBy: Cookies.get("user_uid"),
            isActive: job.isActive ?? true,
        }
    }


    async fetchApplicants({ jobId, page = 1, size = 8 } = {}) {
        const res = await fetch(
            `${this.baseApi}/getJobInfo?jobId=${jobId}&page=${page}&size=${size}`,
            {
                method: "GET",
                headers: this.getHeaders(),
            }
        )
        return await res.json()
    }



    // -----------------------------------------
    // CREATE JOB
    // -----------------------------------------

    async createJob(job) {

        const payload = this.toPayload(job)

        const res = await fetch(`${this.baseApi}/createJob`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify({
                job: payload
            })
        })

        return await res.json()
    }

    // -----------------------------------------
    // UPDATE JOB
    // -----------------------------------------

    async updateJob(jobId, job) {

        const payload = this.toPayload(job)

        const res = await fetch(`${this.baseApi}/updateJob`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify({
                jobId,
                updates: payload
            })
        })

        return await res.json()
    }

    // -----------------------------------------
    // DELETE JOB
    // -----------------------------------------

    async deleteJob(jobId) {
        const res = await fetch(`${this.baseApi}/deleteJob`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify({ jobId })
        })
        return await res.json()
    }

    // -----------------------------------------
    // FETCH JOBS (SEARCH + PAGINATION)
    // -----------------------------------------

    async fetchJobs({
        page = 1,
        size = 10,
        search = "",
        genre = null,
        employmentType = null,
        workMode = null,
        isActive = true,
        totalCount = false
    } = {}) {
        const body = {
            page,
            size,
            search,
            filters: {
                genre,
                employmentType,
                workMode,
                isActive
            },
            totalCount,
            fetchAll: true,
        }

        const res = await fetch(`${this.baseApi}/queryJobs`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(body)
        })

        const data = await res.json()

        return data
    }

    // -----------------------------------------
    // EXPORT APPLICANTS CSV
    // -----------------------------------------
    async exportApplicantsCSV(jobId) {
        const res = await fetch(
            `${this.baseApi}/exportToCSV?jobId=${jobId}`,
            {
                method: "GET",
                headers: this.getHeaders(),
            }
        )

        if (!res.ok) return { success: false }

        const blob = await res.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `applicants-${jobId}.csv`
        a.click()
        URL.revokeObjectURL(url)

        return { success: true }
    }

}

export default PlacementService